(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/match-view-list-item.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/match-view-list-item.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.MatchViewListItem = Backbone.Marionette.View.extend({
    className: 'block js-slider-slide slider-slide js-match-view-list-item',
    modelEvents: {
      'change buttonBet currentMatchChanged': 'render'
    },
    events: {
      setMatch: 'setMatch'
    },

    log: new svs.core.log.Logger('svs.tipset.views.MatchViewListItem'),

    template: function(data) {
      return svs.tipset.templates.matchviewlistitem(data);
    },

    setMatch: function() {
      this.model.setCurrentMatch();
    },

    onClose: function() {
      this.undelegateEvents();
      this.stopListening();
    },

    onDestroy: function() {
      this.onClose();
    }
  });
})(Backbone, _, svs);

 })(window);